// Storage keys
export const STORAGE_KEYS = {
  CERTIFICATE: 'CKEY'
} as const;

type StorageValue = object;

export const StorageService = {
  set<T extends StorageValue>(key: string, data: T) {
    localStorage.setItem(key, JSON.stringify(data));
  },

  get<T extends StorageValue>(key: string): T | null {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  },

  update<T extends StorageValue>(key: string, partial: Partial<T>) {
    const current = StorageService.get<T>(key) || ({} as T);
    const updated = { ...current, ...partial };
    localStorage.setItem(key, JSON.stringify(updated));
  },

  clear(key: string) {
    localStorage.removeItem(key);
  },

  clearAll() {
    localStorage.clear();
  }
};